import { useContext } from "react";
import { DefaultLayout } from "../../../layouts/DefaultLayout";
import Grid from "@mui/material/Unstable_Grid2";
import { AppContext } from "../../../pages/root/Root";

import { ProviderWorkflowMonitoring } from "../../../components/media/providerWorkflowMonitoring/ProviderWorkflowMonitoring";

export const ProviderWorkflowMonitoringPage = () => {
  useContext(AppContext);

  return (
    <DefaultLayout>
      <Grid
        className="page-content"
        container
        rowSpacing={{ xs: 3, md: 0 }}
        columnSpacing={{ xs: 0, md: 2 }}
        padding={{ xs: 1, md: 2 }}
        disableEqualOverflow
      >
        <Grid md={12}>
          <ProviderWorkflowMonitoring />
        </Grid>
      </Grid>
    </DefaultLayout>
  );
};
